import { render, staticRenderFns } from "./OrganizationDashboardTab.vue?vue&type=template&id=829a477e&scoped=true"
import script from "./OrganizationDashboardTab.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationDashboardTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationDashboardTab.vue?vue&type=style&index=0&id=829a477e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829a477e",
  null
  
)

export default component.exports